/* ============================================================================
   batida-free-delivery.js  —  BS-73 free-delivery engine
   ----------------------------------------------------------------------------
   Reads ONE config object, window.batidaFD, printed by the editable section
   sections/batida-free-delivery-bar.liquid (schema = single source of truth for
   threshold + the three messages). Drives all three surfaces from it:

     1. Top BAR  — [data-batida-fd-bar] / [data-batida-fd-text] (empty → progress
        → qualified). Server-rendered to the right state; we keep it in sync.
     2. Cart DRAWER bar — injected into #batida-cart-drawer's footer (custom drawer
        replaced Pipeline's; native message never renders there). drawer.js untouched.
     3. Zapiet "Za darmo!" pill — pure-CSS ::after on the delivery/shipping method
        cards, gated on <html>.bfd-qualified (toggled here).

   BS-82 (2026-06-04): SURFACE 4 added — smart "domknij koszyk" product nudge under
   the drawer bar. Picks from window.batidaFDNudge (eligible "Zamów na jutro"
   products, >=15 zł, available, rendered by zip-cookies.liquid): cheapest single
   item that closes the gap -> "Dodaj X i masz darmową dostawę"; if none can,
   bestseller fallback -> honest "coraz bliżej" copy. Excludes anything already in
   cart. One-tap add reuses the drawer's add+refresh pattern (POST /cart/add.js ->
   /cart.js -> theme:cart:change). Lives inside this engine = one observer / one
   render cycle (no competing observers vs drawer.js). Surfaces 1-3 unchanged.

   BS-91 (2026-06-06): SURFACE 5 added — the same progress bar on the cart PAGE,
   mounted right after [data-line-items] (under the product list, above the
   Zapiet method pills). Rendered whenever the cart is non-empty, regardless of
   chosen pickup/delivery method (Caroline's call — the threshold motivates
   spend across the board). Uses the same three section messages.

   Change the amount / messages in the section settings → flows to all surfaces.
   Basis: original (pre-discount) line prices of the lines that need shipping, i.e. requires_shipping !== false - the
   way Batida Connect's rate engine counts at the checkout (29.09: a T-shirt, its InPost fee and the tasting do not
   count). A cart with nothing to ship reads like an empty one: the generic top line, no progress boxes.
   Per-locale message text: translate the section settings in Translate & Adapt.
   ============================================================================ */
(function () {
  if (window.__batidaFreeDeliveryLoaded) return;
  window.__batidaFreeDeliveryLoaded = true;

  var FD = window.batidaFD || {};
  var LEGACY = window.batidaFreeDelivery || {};
  var THRESHOLD = parseInt(FD.threshold != null ? FD.threshold : LEGACY.threshold, 10);
  if (!THRESHOLD || THRESHOLD < 0) THRESHOLD = 50000; // 500 zł fallback (minor units)

  // 29.09: translated texts arrive HTML-escaped (Liquid's t filter: "You&#39;re") - decode them once; the top bar sets
  // textContent, the drawer/cart box escapes them again (esc) before innerHTML
  function unesc(s) { var t = document.createElement('textarea'); t.innerHTML = String(s || ''); return t.value; }
  var MSG_EMPTY    = unesc(FD.msgEmpty    || 'Darmowa dostawa od ||amount||');
  var MSG_PROGRESS = unesc(FD.msgProgress || 'Do darmowej dostawy brakuje ||amount||');   // 29.09 wording (Aleksandra)
  var MSG_SUCCESS  = unesc(FD.msgSuccess  || 'Masz darmową dostawę');
  // 3.10 (Aleksandra, UX audit point 2): batida.pl delivery needs a minimum (FD.min, grosze; 0 = none, b2b): an empty cart
  // reads "Dostawa od 200 zł · gratis od 500 zł" (||min||), a cart below it "Brakuje Ci X zł do dostawy"
  var MIN = parseInt(FD.min, 10) || 0;
  var MSG_MIN = unesc(FD.msgMin || 'Brakuje Ci ||amount|| do dostawy');

  // BS-82: nudge copy per locale (hardcoded incl. uk to dodge the uk.json key cap).
  // {name} = product title. Button label = .add.
  var NUDGE_TX = {
    pl: { win: 'Dodaj {name} i masz darmową dostawę', near: 'Dorzuć {name} — coraz bliżej darmowej dostawy', add: 'Dodaj', prev: 'Poprzednia propozycja', next: 'Następna propozycja' },
    en: { win: 'Add {name} and delivery is free', near: 'Add {name} — closer to free delivery', add: 'Add', prev: 'Previous suggestion', next: 'Next suggestion' },
    de: { win: '{name} hinzufügen und Versand ist gratis', near: '{name} dazu — näher an Gratisversand', add: 'Hinzufügen', prev: 'Vorheriger Vorschlag', next: 'Nächster Vorschlag' },
    fr: { win: 'Ajoute {name} et la livraison est offerte', near: 'Ajoute {name} — au plus près de la livraison offerte', add: 'Ajouter', prev: 'Suggestion précédente', next: 'Suggestion suivante' },
    uk: { win: 'Додай {name} і доставка безкоштовна', near: 'Додай {name} — ближче до безкоштовної доставки', add: 'Додати', prev: 'Попередня пропозиція', next: 'Наступна пропозиція' }
  };

  // 29.09 (Aleksandra: prices ALWAYS with grosze): price() for prices and the amount still missing ("Jeszcze 281,00 zł"),
  // window.batidaMoney = the site-wide helper (layout/theme.liquid); money() only for the threshold ("od 500 zł").
  function money(cents) {
    var a = (cents || 0) / 100;
    return a.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' zł';
  }
  function price(cents) { return window.batidaMoney ? window.batidaMoney(cents || 0) : ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function amt(cents) { return money(cents) + (FD.net ? ' ' + (FD.netWord || 'netto') : ''); }   // threshold amounts (28.09: companies' net)
  function rest(cents) { return price(cents) + (FD.net ? ' ' + (FD.netWord || 'netto') : ''); }  // the amount still missing
  function esc(s) {
    return (s == null ? '' : '' + s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var state = { basis: null, itemPids: {} };

  function shippable(cart) {
    return (cart.items && cart.items.filter) ? cart.items.filter(function (it) { return it && it.requires_shipping !== false; }) : null;
  }
  // 4.10 (Aleksandra's audit): on b2b the bar counts only B2B products. cart.js has no tags, so the lines' B2B flag comes
  // from /cart?view=split (templates/cart.split.liquid, also used by assets/batida-cart-split.js); cached per line key.
  var b2bKeys = null, b2bKeysFor = '';
  function withB2bKeys(cart, done) {
    var keys = (cart.items || []).map(function (it) { return it.key; }).sort().join(',');
    if (b2bKeys && b2bKeysFor === keys) return done();
    var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
    fetch(root + '/cart?view=split', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('split'); return r.json(); })
      .then(function (s) { b2bKeys = {}; (s.items || []).forEach(function (i) { if (i.b2b) b2bKeys[i.key] = true; }); b2bKeysFor = keys; done(); })
      .catch(function () { done(); });   // unknown: count everything, as before
  }
  function setFromCart(cart) {
    if (!cart) return;
    if (FD.b2bOnly && cart.items && cart.items.length && !cart.__bfdB2b) {
      return withB2bKeys(cart, function () {
        var c = {}; Object.keys(cart).forEach(function (k) { c[k] = cart[k]; });
        if (b2bKeys) c.items = cart.items.filter(function (it) { return b2bKeys[it.key]; });
        c.__bfdB2b = true; setFromCart(c);
      });
    }
    var b = (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart.total_price;
    var ship = shippable(cart);
    // 29.09: only the lines that need shipping count (the checkout's rule); a T-shirt-only cart = basis 0
    if (ship) b = ship.reduce(function (s, it) { return s + ((it.original_line_price != null ? it.original_line_price : it.final_line_price) || 0); }, 0);
    // 28.09: a net threshold (companies, "od 1000 zł netto") = the cart's net value, syrups 23 %, the rest 5 %
    if (FD.net && ship) {
      b = ship.reduce(function (s, it) { var vat = /syrop/i.test(it.product_type || '') ? 23 : 5; return s + Math.round((it.original_line_price != null ? it.original_line_price : it.final_line_price) / (1 + vat / 100)); }, 0);
    }
    state.itemPids = {};
    if (cart.items && cart.items.forEach) {
      cart.items.forEach(function (it) { if (it && it.product_id != null) state.itemPids[it.product_id] = true; });
    }
    if (typeof b === 'number') { state.basis = b; renderAll(); }
  }
  function fetchCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root.replace(/\/$/, '') + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setFromCart(c); return c; })
      .catch(function () {});
  }
  function model() {
    var b = state.basis;
    if (b == null) return null;
    var rem = THRESHOLD - b;
    var below = MIN > 0 && b > 0 && b < MIN;
    return { basis: b, remaining: rem, qualified: rem <= 0, empty: b === 0, belowMin: below, minRemaining: MIN - b,
      pct: Math.max(0, Math.min(100, Math.round((b / (below ? MIN : THRESHOLD)) * 100))) };
  }

  function barText(m) {
    if (m.empty) return MSG_EMPTY.replace('||amount||', amt(THRESHOLD)).replace('||min||', amt(MIN));
    if (m.belowMin) return MSG_MIN.replace('||amount||', rest(m.minRemaining));
    if (m.qualified) return MSG_SUCCESS;
    return MSG_PROGRESS.replace('||amount||', rest(m.remaining));
  }

  // ---- surface 1: top bar ------------------------------------------------
  function renderBar(m) {
    var bar = document.querySelector('[data-batida-fd-bar]');
    if (!bar) return;
    var txt = bar.querySelector('[data-batida-fd-text]') || bar;
    txt.textContent = barText(m);
    bar.classList.toggle('is-qualified', !!m.qualified);
  }

  // ---- surface 2: cart drawer (inject; do not edit drawer.js) -------------
  // The icon span and the goal amount (data-goal) are styled only on the cart page of the new look (batida-b2c.css);
  // the drawer hides the icon. The missing amount is bold everywhere.
  function drawerBarHTML(m) {
    var msg = m.qualified ? esc(MSG_SUCCESS) : m.belowMin ? esc(MSG_MIN).replace('||amount||', '<strong class="bfd-bar__amt">' + esc(rest(m.minRemaining)) + '</strong>') : esc(MSG_PROGRESS).replace('||amount||', '<strong class="bfd-bar__amt">' + esc(rest(m.remaining)) + '</strong>');
    return '' +
      '<div class="bfd-bar' + (m.qualified ? ' is-qualified' : '') + '" role="status" aria-live="polite">' +
        '<span class="bfd-bar__ico" aria-hidden="true"></span>' +
        '<p class="bfd-bar__msg">' + (m.qualified ? '<span class="bfd-bar__check" aria-hidden="true">✓</span> ' : '') + msg + '</p>' +
        '<div class="bfd-bar__track" data-goal="' + esc(amt(m.belowMin ? MIN : THRESHOLD)) + '"><div class="bfd-bar__fill" style="width:' + m.pct + '%"></div></div>' +
      '</div>';
  }

  // ---- surface 4 (BS-82): smart, BROWSABLE product nudge under the drawer bar
  // Customer can flip through up to NUDGE_MAX suggestions (prev/next + dots).
  // Ordering: cheapest items that CLOSE the gap first (each shows the "win" copy),
  // then bestsellers, then the rest cheapest-first (these show the honest "coraz
  // bliżej" copy). Eligible = "Zamów na jutro", price > 16 zł (1600 minor units),
  // not already in cart. The displayed item's variant rides the Dodaj button.
  var NUDGE_MAX = 5;
  var NUDGE = { cands: [], idx: 0, sig: '', gap: 0 };

  function computeCandidates(gap) {
    var cfg = window.batidaFDNudge || {};
    var inCart = state.itemPids || {};
    var prods = (cfg.products || []).filter(function (p) { return p && p.price > 1600 && !inCart[p.pid]; });
    if (!prods.length) return [];
    var closers = prods.filter(function (p) { return p.price >= gap; }).sort(function (a, b) { return a.price - b.price; });
    var rest = prods.filter(function (p) { return p.price < gap; });
    var bs = rest.filter(function (p) { return p.bs; }).sort(function (a, b) { return a.price - b.price; });
    var others = rest.filter(function (p) { return !p.bs; }).sort(function (a, b) { return a.price - b.price; });
    return closers.concat(bs, others).slice(0, NUDGE_MAX);
  }
  function removeNudge(footer) {
    var el = footer && footer.querySelector('[data-batida-fd="nudge"]');
    if (el) el.remove();
  }
  function nudgeInnerHTML() {
    var c = NUDGE.cands[NUDGE.idx];
    if (!c) return '';
    var win = c.price >= NUDGE.gap;
    var lang = (document.documentElement.lang || 'pl').toLowerCase().split('-')[0];
    var T = NUDGE_TX[lang] || NUDGE_TX.pl;
    var name = c.t || '';
    var hint = (win ? T.win : T.near).replace('{name}', name);
    var imgHTML = c.img
      ? '<img class="bfd-nudge__img" src="' + esc(c.img) + '" alt="" loading="lazy">'
      : '<span class="bfd-nudge__img bfd-nudge__img--ph" aria-hidden="true"></span>';
    var card =
      '<div class="bfd-nudge__card' + (win ? ' is-win' : '') + '">' +
        imgHTML +
        '<div class="bfd-nudge__body">' +
          '<p class="bfd-nudge__hint">' + esc(hint) + '</p>' +
          '<p class="bfd-nudge__name">' + esc(name) + ' <span>· ' + price(c.price) + '</span></p>' +
        '</div>' +
        '<button type="button" class="bfd-nudge__add" data-batida-fd-add data-variant-id="' + c.id + '">' + esc(T.add) + '</button>' +
      '</div>';
    if (NUDGE.cands.length < 2) return card;
    var dots = '';
    for (var i = 0; i < NUDGE.cands.length; i++) dots += '<span class="bfd-nudge__dot' + (i === NUDGE.idx ? ' is-on' : '') + '"></span>';
    var nav =
      '<div class="bfd-nudge__nav">' +
        '<button type="button" class="bfd-nudge__navbtn" data-batida-fd-nav="prev" aria-label="' + esc(T.prev) + '">&lsaquo;</button>' +
        '<span class="bfd-nudge__dots" aria-hidden="true">' + dots + '</span>' +
        '<button type="button" class="bfd-nudge__navbtn" data-batida-fd-nav="next" aria-label="' + esc(T.next) + '">&rsaquo;</button>' +
      '</div>';
    return card + nav;
  }
  function paintNudge() {
    var drawer = document.getElementById('batida-cart-drawer');
    var footer = drawer && drawer.querySelector('[data-batida-cart-footer]');
    var el = footer && footer.querySelector('[data-batida-fd="nudge"]');
    if (!el) return;
    DRAWER_WRITING = true;
    el.innerHTML = nudgeInnerHTML();
    DRAWER_WRITING = false;
  }
  function renderNudge(footer, barMount, m) {
    if (!m || m.qualified || m.empty || m.remaining <= 0) { removeNudge(footer); return; }
    NUDGE.gap = m.remaining;
    var cands = computeCandidates(m.remaining);
    if (!cands.length) { removeNudge(footer); return; }
    var sig = cands.map(function (c) { return c.id; }).join(',');
    if (sig !== NUDGE.sig) { NUDGE.sig = sig; NUDGE.idx = 0; }   // new set -> reset to first
    NUDGE.cands = cands;
    if (NUDGE.idx >= cands.length) NUDGE.idx = 0;
    var el = footer.querySelector('[data-batida-fd="nudge"]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-batida-fd', 'nudge');
      if (barMount && barMount.parentNode === footer) footer.insertBefore(el, barMount.nextSibling);
      else footer.insertBefore(el, footer.firstChild);
    }
    el.innerHTML = nudgeInnerHTML();
  }

  var DRAWER_WRITING = false;
  function renderDrawer(m) {
    var drawer = document.getElementById('batida-cart-drawer');
    if (!drawer) return;
    var footer = drawer.querySelector('[data-batida-cart-footer]');
    if (!footer) return;
    var mount = footer.querySelector('[data-batida-fd="drawer"]');
    if (!m || m.empty) { if (mount) mount.remove(); removeNudge(footer); return; }
    DRAWER_WRITING = true;
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-batida-fd', 'drawer');
      footer.insertBefore(mount, footer.firstChild);
    }
    mount.innerHTML = drawerBarHTML(m);
    renderNudge(footer, mount, m);
    DRAWER_WRITING = false;
  }
  var DRAWER_T;
  function watchDrawer() {
    var drawer = document.getElementById('batida-cart-drawer');
    if (!drawer || drawer.__bfdWatched) return;
    drawer.__bfdWatched = true;
    try {
      new MutationObserver(function (muts) {
        if (DRAWER_WRITING) return;
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].target.closest && (muts[i].target.closest('[data-batida-fd="drawer"]') || muts[i].target.closest('[data-batida-fd="nudge"]'))) return;
        }
        // Drawer re-rendered (open / qty +/- / remove). Batida's drawer doesn't
        // emit theme:cart:change on qty change, so re-FETCH the cart to refresh
        // the basis, then renderAll updates the bar + drawer bar + nudge + pill together.
        clearTimeout(DRAWER_T); DRAWER_T = setTimeout(fetchCart, 150);
      }).observe(drawer, { childList: true, subtree: true });
    } catch (e) {}
  }
  (function pollDrawer(n) {
    if (document.getElementById('batida-cart-drawer')) { watchDrawer(); return; }
    if (n <= 0) return;
    setTimeout(function () { pollDrawer(n - 1); }, 400);
  })(15);

  // ---- surface 3: Zapiet pill (pure CSS, gated on <html> class) -----------
  function renderZapietPill(m) {
    document.documentElement.classList.toggle('bfd-qualified', !!(m && m.qualified));
  }

  // ---- surface 5 (BS-91): cart PAGE bar, under the line-item list ----------
  // Mounts as a SIBLING right after [data-line-items] (the anchor only exists
  // on /cart, so this is a no-op everywhere else). Always rendered when the
  // cart is non-empty — no method gating (Caroline, 2026-06-06). Because the
  // mount sits OUTSIDE [data-line-items], Pipeline's AJAX line-item re-renders
  // don't wipe it, and the engine's cart-page observer (which watches
  // [data-line-items] only) never sees our own writes — no feedback loop.
  function renderCartPage(m) {
    var anchor = document.querySelector('[data-line-items]');
    if (!anchor || !anchor.parentNode) return;
    var mount = document.querySelector('[data-batida-fd="cartpage"]');
    if (!m || m.empty) { if (mount) mount.remove(); return; }
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-batida-fd', 'cartpage');
      anchor.parentNode.insertBefore(mount, anchor.nextSibling);
    }
    mount.innerHTML = drawerBarHTML(m);
  }

  function renderAll() {
    var m = model();
    if (!m) return;
    renderBar(m);
    renderDrawer(m);
    renderCartPage(m);
    renderZapietPill(m);
  }

  // ---- BS-82: one-tap "Dodaj" handler (delegated; reuses drawer pattern) --
  var ADD_BOUND = false;
  function bindAdd() {
    if (ADD_BOUND) return;
    ADD_BOUND = true;
    document.addEventListener('click', function (e) {
      // browse prev/next through suggestions (no cart fetch — just repaint)
      var nav = e.target && e.target.closest && e.target.closest('[data-batida-fd-nav]');
      if (nav) {
        e.preventDefault();
        var len = NUDGE.cands.length;
        if (len < 2) return;
        var dir = nav.getAttribute('data-batida-fd-nav') === 'prev' ? -1 : 1;
        NUDGE.idx = (NUDGE.idx + dir + len) % len;
        paintNudge();
        return;
      }
      var btn = e.target && e.target.closest && e.target.closest('[data-batida-fd-add]');
      if (!btn || btn.disabled) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      e.preventDefault();
      btn.disabled = true; btn.classList.add('is-loading');
      var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
      fetch(root + '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch(root + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (fullCart) { try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: fullCart } })); } catch (e2) {} })
        .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    }, false);
  }

  // ---- triggers ----------------------------------------------------------
  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) setFromCart(e.detail.cart);
    else fetchCart();
    setTimeout(function () { var m = model(); if (m) renderDrawer(m); }, 150);
  });

  // Cart PAGE doesn't emit cart events on qty change (Pipeline quirk, BS-66/v55b)
  // -> observe line items so the bar + pill stay in sync.
  (function watchCartPage() {
    if (!document.querySelector('#storePickupApp')) return;
    var li = document.querySelector('[data-line-items]') || document.querySelector('[data-cart-form]');
    if (!li) return;
    var t;
    try {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(fetchCart, 250); })
        .observe(li, { childList: true, subtree: true });
    } catch (e) {}
  })();

  function start() { bindAdd(); fetchCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.__batidaFreeDelivery = { refresh: fetchCart, model: model };
})();
